export default [
	{
		clave: 'Central Standard Time (Mexico)',
		descripcion: 'Guadalajara, Ciudad de México, Monterrey'
	},
	{
		clave: 'Mountain Standard Time (Mexico)',
		descripcion: 'Chihuahua, La Paz, Mazatlán'
	},
	{ clave: 'Pacific Standard Time (Mexico)', descripcion: 'Baja California' }
];
// "timeZone": "Pacific Standard Time (Mexico)",
// "timeZone": "Mountain Standard Time (Mexico)",
// "timeZone": "Central Standard Time (Mexico)",
// "timeZone": "Eastern Standard Time (Mexico)",
